/**
 * UID generation utilities for supplement editor.
 */

/** Counter-based UID generator. Returns incrementing numbers starting from 1. */
export function createUidGenerator() {
  let counter = 0;
  return () => ++counter;
}

/** WeakMap-based UID generator for stable IDs across re-renders. */
export function createWeakMapUidGenerator(prefix = "") {
  const uiIdMap = new WeakMap();
  let counter = 0;

  return (item) => {
    if (!item) return null;
    if (!uiIdMap.has(item)) {
      uiIdMap.set(item, `${prefix}${Date.now()}_${counter++}`);
    }
    return uiIdMap.get(item);
  };
}

/** Assign UIDs to array of items using provided generator. */
export function assignUids(items, uidGenerator) {
  return (items || []).map((item) => ({
    ...item,
    _uid: uidGenerator(),
  }));
}

/** Strip _uid properties from array of items. */
export function stripUids(items) {
  return items.map(({ _uid, ...rest }) => rest);
}

/** Parse a UID value from a DOM dataset attribute. */
export function parseUid(val) {
  if (typeof val === "number") return val;
  const n = Number(val);
  return isNaN(n) ? val : n;
}
